import {Session, QUERY_SESSIONS, QuerySessions} from "./types";

export const querySessions = (sessions: Session[]): QuerySessions => {
    return {
        type: QUERY_SESSIONS,
        payload: sessions
    }
}
